// import { useAuth } from '@hooks/useAuth';
import { getUsuarios, getTipoUsuario, getUsuario, verifyAndActivate, userChagePlan, deleteUserData, changePlanVto, getPaginacionUsuarios } from "services/Usuarios";
import { useState } from "react";


const useUsers = () => {
    const [isLoading, setIsLoading] = useState(false)
    // response solo debería guardar la lista de usuarios (el array), no el objeto paginado completo
    const [response, setResponse] = useState([]) 
    const [error, setError] = useState(null)

    /**
     * Función fetchData actualizada para aceptar parámetros de paginación y búsqueda.
     * @param {number | null} id 
     * @param {boolean} withReturn - Si es true, retorna el objeto de la API (incluye 'pagination' si es paginado).
     * @param {string | null} type - Tipo de usuario para filtrar.
     * @param {number} page - Número de página actual (por defecto 1).
     * @param {number} pageSize - Elementos por página (por defecto 20).
     * @param {string} query - Término de búsqueda (por defecto '').
     * @param {string} orderBy - Campo de orden (por defecto 'last_login_at').
     * @param {string} orderDirection - Dirección de orden (por defecto 'desc').
     */
    const fetchData = async (
        id = null,
        withReturn = false,
        type = null,
        page = 1,
        pageSize = 20,
        query = '',
        orderBy = 'last_login_at',
        orderDirection = 'desc'
    ) => {
        setError(null)
        setIsLoading(true)

        try {
            let data; // Almacenará el resultado de la llamada (Puede ser un usuario, un array o el objeto paginado {data:..., pagination:...})

            if (id) {
                data = await getUsuario(id)
            } else if (type) {
                // 1. 🆕 Pasa los nuevos parámetros a getPaginacionUsuarios
                data = await getPaginacionUsuarios(type, page, pageSize, query, orderBy, orderDirection)
            } else {
                data = await getUsuarios()
            }

            if (withReturn) {
                setIsLoading(false)
                
                // 2. 🆕 Si es paginado (data contiene data y pagination), retorna el objeto completo.
                // Si es un ID, retorna el primer elemento.
                return id ? data[0] : data
            }

            // 3. 🆕 Si no se usa withReturn, actualiza el estado 'response' con la lista de usuarios.
            // Si data es un objeto paginado, toma data.data. Si es un array/usuario, toma data.
            const responseData = (type && data.data) ? data.data : data;

            setResponse(responseData)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
            // En caso de error, limpia el response
            setResponse([])
        } finally {
            setIsLoading(false)
        }
    }

    const getInstituciones = async () => {
        // Esta función ya no tiene sentido si usamos la paginación con type="I"
        // Si aún quieres usarla, asegúrate de que getPaginacionUsuarios/getUsuarios devuelve todos los datos
        // y luego se filtra.
        const data = await fetchData(null, true) 

        return data?.filter(user => user?.type === 'I')
    }

    const verifyAccount = async (id, payload) => {
        await verifyAndActivate(id, payload)
    }

    const changePlan = async (userId, planId) => {
        await userChagePlan(userId, planId)
    }

    const changeVtoPlan = async (data) => {
        await changePlanVto(data)
    }

    const deleteUser = async (userId) => {
        await deleteUserData(userId)
    }

    return { response, changePlan, isLoading, error, fetchData, verifyAccount, deleteUser, getInstituciones, changeVtoPlan }
}


export default useUsers
